// extracted by mini-css-extract-plugin
export default {"video-background":"VideoBackground_video-background__CjGLJ","video-overlay":"VideoBackground_video-overlay__otFiK"};